/* eslint no-unused-vars: 0 */
import React, { Component } from 'react';
import { connect } from 'react-redux';

export class PageError extends Component {
    setError() {
        return { __html: this.props.errorMessage };
    }

    render() {
        if (!this.props.error) {
            return <div></div>;
        }

        return (
            <div className="app__page-error" dangerouslySetInnerHTML={ this.setError() }></div>
        );
    }
}

PageError.propTypes = {
    error: React.PropTypes.bool,
    errorMessage: React.PropTypes.string,
};

function mapStateToProps(state) {
    return {
        error: state.reducer.get('error'),
        errorMessage: state.reducer.get('errorMessage'),
    };
}

export default connect(mapStateToProps)(PageError);



// WEBPACK FOOTER //
// ./src/components/PageError.jsx